<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="list"
      :search="search"
      :options="options"
    >
        <template v-slot:[`item.state`]="{ item }">
           <v-img :src="getFlag(item.state)" 
                  :lazy-src="getFlag(item.state)" 
                  max-height="35" max-width="35"
                  :alt=item.state 
                  v-bind:title="item.state"
            >
          </v-img>
        </template>
  
    </v-data-table>
  </v-card>
</template>

<script>
import { supabase } from '../supabase'

  export default {
    data () {
      return {
        options: {
          itemsPerPage : 15
        },
        search: '',
        headers: [
          {
            text: 'Parliament Number',
            align: 'start',
            value: 'parliament_number',
          },
          { text: 'Constituency', value: 'constituency' },
          { text: 'State', value: 'state' },
          { text: 'Member', value: 'member_name' },
          { text: 'Party', value: 'party' },
          { text: 'Coalition', value: 'coalition' },
        ],
        list: [],
        flags: [
          {
            state: 'Perlis',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Flag_of_Perlis.svg/35px-Flag_of_Perlis.svg.png'
          }, 
          {
            state: 'Kedah',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Flag_of_Kedah.svg/35px-Flag_of_Kedah.svg.png'
          },
          {
            state: 'Kelantan',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Flag_of_Kelantan.svg/35px-Flag_of_Kelantan.svg.png'
          },
          {
            state: 'Terengganu',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Flag_of_Terengganu.svg/35px-Flag_of_Terengganu.svg.png'
          },
          {
            state: 'Kedah',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Flag_of_Kedah.svg/35px-Flag_of_Kedah.svg.png'
          },
          {
            state: 'Terengganu',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Flag_of_Penang_%28Malaysia%29.svg/35px-Flag_of_Penang_%28Malaysia%29.svg.png'
          },
          {
            state: 'Kedah',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Flag_of_Kedah.svg/35px-Flag_of_Kedah.svg.png'
          },
          {
            state: 'Penang',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Flag_of_Penang_%28Malaysia%29.svg/35px-Flag_of_Penang_%28Malaysia%29.svg.png'
          },
          {
            state: 'Kedah',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Flag_of_Kedah.svg/35px-Flag_of_Kedah.svg.png'
          },
          {
            state: 'Perak',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Flag_of_Perak.svg/35px-Flag_of_Perak.svg.png'
          },
          {
            state: 'Pahang',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Flag_of_Pahang.svg/35px-Flag_of_Pahang.svg.png'
          },
          {
            state: 'Selangor',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Flag_of_Selangor.svg/35px-Flag_of_Selangor.svg.png'
          },
          {
            state: 'Federal Territory of Kuala Lumpur',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Flag_of_Kuala_Lumpur%2C_Malaysia.svg/35px-Flag_of_Kuala_Lumpur%2C_Malaysia.svg.png'
          },
          {
            state: 'Federal Territory of Putrajaya',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Flag_of_Putrajaya.svg/35px-Flag_of_Putrajaya.svg.png'
          },
          {
            state: 'Negeri Sembilan',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Flag_of_Negeri_Sembilan.svg/35px-Flag_of_Negeri_Sembilan.svg.png'
          },
          {
            state: 'Malacca',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_Malacca.svg/35px-Flag_of_Malacca.svg.png'
          },
          {
            state: 'Johor',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Flag_of_Johor.svg/35px-Flag_of_Johor.svg.png'
          },
          {
            state: 'Federal Territory of Labuan',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Flag_of_Labuan.svg/35px-Flag_of_Labuan.svg.png'
          },
          {
            state: 'Sabah',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Flag_of_Sabah.svg/35px-Flag_of_Sabah.svg.png'
          },
          {
            state: 'Sarawak',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Flag_of_Sarawak.svg/35px-Flag_of_Sarawak.svg.png'
          }
        ]
      }
    },
    mounted(){
      this.getData()
    },
    methods: {
      async getData(){
        try {
          
          let { data, error, status } = await supabase
            .from('parliament_members')
            .select('*')
            .order('parliament_number', {ascending : true})
          if (error && status !== 406) throw error

          if (data) {
            this.list = data
          }
        } catch (error) {
          alert(error.message)
        } 
      }, 
      getFlag(state){
        for (var obj of this.flags){
          if (obj.state === state){
            return obj.flag
          }
        }
        return null
      }
    }
  }
</script>

<style></style>